class ProductMain extends ProductInfo {
  constructor() {
    super();
    try {
      this.initDetailDialog();
    } catch (e) {
      console.warn('[product-main] enhancement skipped:', e);
    }
  }

  setScrollHandle() {
    let fixedBox = this.querySelector('.product-main-fixed');
    let scrollBox = fixedBox.querySelector('.product-main-scroll');
    let scrollLength = scrollBox.offsetHeight - fixedBox.offsetHeight;
    if (scrollLength > 0) {
      scrollLength += 200;
      let parentDom = this.parentElement;
      parentDom.style.height = `${this.offsetHeight + scrollLength * 2}px`;
      let header = document.querySelector('.section-header');
      ScrollTrigger.create({
        id: 'product-main',
        trigger: parentDom,
        start: () => 'top top',
        end: () => 'bottom bottom',
        scrub: 1,
        markers: false,
        animation: gsap.fromTo(scrollBox, { y: 0 }, { y: -scrollLength }),
        onUpdate: (self) => {
          header.style.setProperty('top', '0px', 'important');
        },
        onLeave: ({ progress, direction, isActive }) => {
          header.style.removeProperty('top');
        },
        onLeaveBack: ({ progress, direction, isActive }) => {
          header.style.removeProperty('top');
        },
      });
    }
  }

  initDetailDialog() {
    let detailBtn = this.querySelector('.detail-pictures-btn');
    if (!detailBtn) return;
    let detailDialog = this.parentElement.querySelector('.detail-pictures-dialog');
    let detailSwiper = new Swiper(detailDialog.querySelector('.swiper'), {
      spaceBetween: 20,
      slidesPerView: 'auto',
      centeredSlides: true,
      grabCursor: true,
      pagination: { el: detailDialog.querySelector('.swiper-pagination') },
      navigation: {
        nextEl: detailDialog.querySelector('.swiper-button-next'),
        prevEl: detailDialog.querySelector('.swiper-button-prev'),
      },
    });
    detailBtn.addEventListener('click', function () {
      detailDialog.classList.add('open');
      document.body.classList.add('overflow-hidden');
    });
    detailDialog.querySelectorAll('.close-btn').forEach((btn) => {
      btn.addEventListener('click', function () {
        detailDialog.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
      });
    });
  }

  updateMedia(html, variantFeaturedMediaId) {
    if (!variantFeaturedMediaId) return;
    let activeImg = this.querySelector(
      `.product-img-list img[data-id="${variantFeaturedMediaId}"]`
    );
    if (activeImg) {
      this.querySelector('.product-img-list img.active').classList.remove('active');
      activeImg.classList.add('active');
    }
  }

  updateVariantNotices(variantId) {
    const id = String(variantId || '');
    this.querySelectorAll('[data-variant-notice]').forEach((el) => {
      const targetId = (el.dataset.variantId || '').trim();
      const show = !targetId || targetId === id;
      el.hidden = !show;
      el.classList.toggle('is-active', show);
    });
  }

  handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
    if (!this.contains(event.target)) return;
    document.querySelector(`#${target.id}`)?.focus();
    let oldImgDom = this.querySelector('.product-img-list img.active');
    let title = oldImgDom?.dataset.title.split(' / ');
    title[target.name.split('-')[1] - 1] = target.value;
    title = title.join(' / ');
    let newImgDom = this.querySelector(`.product-img-list img[data-title="${title}"]`);
    if (!newImgDom) return;
    oldImgDom.classList.remove('active');
    newImgDom.classList.add('active');
    const variant_id = newImgDom.dataset.variant_id;
    const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
    this.updateURL(productUrl, variant_id);
    this.updateVariantInputs(variant_id);
    this.updateVariantNotices(variant_id);
    const price = newImgDom.dataset.price;
    const pe = this.querySelector(`#price-${this.dataset.section} .price__regular .price-item`);
    if (pe && price) pe.innerHTML = price;
    const sectionId = this.dataset.section;
    const productForm = this.productForm;
    const requestId = (this.variantRequestId || 0) + 1;
    this.variantRequestId = requestId;
    productForm?.toggleSubmitButton(true);
    this.dataset.available = 'false';
    fetch(`${productUrl}?variant=${variant_id}&section_id=${sectionId}`, {
      headers: { Accept: 'text/html' },
    })
      .then((r) => {
        if (!r.ok) throw new Error('Variant request failed');
        return r.text();
      })
      .then((txt) => {
        if (requestId !== this.variantRequestId) return;
        const doc = new DOMParser().parseFromString(txt, 'text/html');
        const btn = doc.querySelector(`#ProductSubmitButton-${sectionId}`);
        const soldOut = btn ? btn.hasAttribute('disabled') : true;
        productForm?.toggleSubmitButton(soldOut, window.variantStrings.soldOut);
        this.dataset.available = String(!soldOut);
        const notices = doc.querySelectorAll('[data-variant-notice]');
        this.querySelectorAll('[data-variant-notice]').forEach((notice, index) => {
          if (notices[index]) notice.innerHTML = notices[index].innerHTML;
        });
        productForm?.handleErrorMessage();
      })
      .catch(() => {
        if (requestId !== this.variantRequestId) return;
        const available = newImgDom.dataset.available === 'true';
        productForm?.toggleSubmitButton(!available, window.variantStrings.soldOut);
        this.dataset.available = String(available);
        productForm?.handleErrorMessage();
      });
  }
}
customElements.get('product-main') || customElements.define('product-main', ProductMain);
